<rt-button variant="tertiary" (click)="copyGeneratedPassword()" layout-centered>
  {{ 'rti.common.copy_password' | translate }}
</rt-button>
